import { Component, createRef } from 'react'
import Head from 'next/head'
import Modal from 'react-modal'
import Page from '../layouts/main'
import CTA from '../components/CTA/cta.module'
import Footer from '../components/Footer/footer.module'
import Picture from '../components/picture/picture.module'
import Video from '../components/video/video.module';
import styles from '../styles/modules/about-us.module.scss'
import settings from '../util/settings'

export default class FAQ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      analytics: {},
      modal: {
        open: false,
        videoURL: ''
      }
    }
    this.page = createRef();
  }

  componentDidMount() {
    if (this.page.current) {
      this.setState({ ...this.state, analytics: this.page.current.analytics })
    }
  }

  toggleModal = (state, videoURL) => {
    this.setState({
      modal: {
        open: state === 'on',
        videoURL: videoURL
      }
    })
  }

  render() {
    const { analytics, modal } = this.state
    return (
      <Page id={styles['page-about-us']} ref={this.page}>
        <Head>
          <title>About Us - Kudos Golf</title>
        </Head>
        <Modal
          isOpen={modal.open}
        >
          <button className='close-button' onClick={ () => this.toggleModal('off') }>&#10005;</button>
          <Video url={ modal.videoURL } controls={true} playing={true} analytics={ analytics } />
        </Modal>

        <section className={`section-content ${styles['section-our-mission']}`}>
          <h2 className={styles.header}>Golf has always been our passion, and we’re always looking for ways to improve our game.</h2>
          <h3 className={styles['our-mission-title']}>Our mission</h3>
          <div className={styles['our-mission-copy']}>
            <p className='text-body-large'>We provide our customers with a state-of-the-art golf simulation experience that will provide real time feedback data at a competitive price point, without putting limits on when you’re able to practice.</p>
            <p className='text-body-large'>The weather is always perfect at Kudos Golf. With all this extra practice, get ready to wow your friends on the golf course.</p>
          </div>
          <div className={styles['kudos-into-video']}>
            <Video url={`${settings.ASSET_PATH}videos/kudos-golf-tour.mp4`} controls={true} playing={true} preview={ `${settings.ASSET_PATH}videos/thumbnail/kudos-golf-tour.jpg` } analytics={ analytics } />
          </div>
        </section>

        <section className={`row section-content ${styles['section-what-we-offer']}`}>
          <span className={`col-md-4 col-lg-5 p-0 ${styles['section-what-we-offer-image']}`}>
            <Picture src={ settings.ASSET_PATH + 'images/about-us/golf-bay.jpg?webp' } alt={'Golf Ball in Hand'} title={'Golf Ball in Hand'} />
          </span>
          <span className={`offset-md-1 col-md-7 col-lg-6 ${styles['section-what-we-offer-content']}`}>
            <h3 className={styles['what-we-offer-section-title']}>What we offer</h3>
            <p className={`text-body-medium ${styles['what-we-offer-section-description']}`}>Kudos Golf uses golf simulators and state-of-the art launch monitors to add an unprecedented leap in real-time accessibility to actual ball spin and club path movement data. Our software includes a driving range, along with over 90 different 18 hole courses, and the ability to track all your hitting statistics.</p>
            <p className={`text-body-medium ${styles['what-we-offer-section-description']}`}>We are open every day of the year, all hours of the day, so you can book a tee time and practice at times that are most convenient for you. We have an easy to use, fully automated booking system so you can guarantee your tee time up to 7 days in advance, and book your session through our website from any device.</p>
            <CTA
              href='/how-it-works'
              className={`button-arrow light ${styles['how-it-works-cta']}`}
              text='How it works'
              analytics={analytics}
              src='/about-us' dest='/how-it-works' />
          </span>
        </section>

        <section id='our-technology' className={`section-content ${styles['section-our-technology']}`}>
          <h3 className={styles['our-technology-title']}>Our technology</h3>
          
          <h4 className={styles['our-technology-subheading']}>What is a golf simulator?</h4>
          <p className={`text-body-medium ${styles['our-technology-copy']}`}>A golf simulator is a full-swing golf system or device that allows you to play golf on a graphically or photographically simulated driving range or golf course in an indoor setting. They are not video games, but simply a computer-run facility that requires golf clubs and form. The ball is aimed at a vinyl screen one shot at a time on a selected golf course (over 90 courses are offered). This is a virtual reality that simulates a true golf experience with tee shots, short game, and putting. With each shot, the golfer is provided with a detailed analysis of the ball flight which can be used for practice and training.</p>
          
          <h4 className={styles['our-technology-subheading']}>How is information tracked and analyzed?</h4>
          <p className={`text-body-medium ${styles['our-technology-copy']}`}>Each golf simulator tracks ball flight or club head motion. Ball flight is tracked through wavelength sensors, infrared, or audio – tracking properties such as launch angle, ball speed and ball direction. Club motion is tracked via wavelength sensors or other devices such tethers, cameras, or lasers. Through the motion of the club, head speed, direction, and point of impact on the club are also shown.</p>

          <h4 className={styles['our-technology-subheading']}>What are the technological advantages?</h4>
          <p className={`text-body-medium ${styles['our-technology-copy']}`}>The key advantage of our full-swing golf simulator is the ability to conveniently play and practice in a controlled environment all year round. Our software delivers unrivalled visual graphics, a user friendly interface, and precise ball and club data analysis. At Kudos Golf, you will be able to track your hitting statistics by&nbsp;
            <CTA
              className={'text-link'}
              text='creating a profile'
              analytics={analytics}
              src='ABOUT-US' dest='kudos-golf-create-profile.mp4'
              onClick={ () => this.toggleModal('on', `${settings.ASSET_PATH}videos/kudos-golf-create-profile.mp4`) } />, and can review your statistics in the&nbsp;
            <CTA
              className={'text-link'}
              href='https://portal.e6golf.com/login'
              text='E6 portal'
              target='_blank'
              analytics={analytics}
              src='ABOUT-US' dest='https://portal.e6golf.com/login' /> after each session. Use your profile to collect statistics on your rounds in practice and courses to analyze your current performance level, so you can determine which areas of your game you excel in, and which areas need improvement.</p>
        </section>

        <Footer />
      </Page>
    )
  }
}